import { graphql } from "~/lib/graphql";

export const responsiveImageFragment = graphql(`
  fragment responsiveImageFragment on ResponsiveImageRecord {
    __typename
    id
    desktopImage {
      id
      height
      width
      url
    }
    mobileImage {
      id
      height
      width
      url
    }
  }
`);
